// Semantic types for autocomplete fields
export enum AutocompleteSemantic {
  CITY = "city", // City / locality
  STREET = "street", // Street address
  NAME = "name", // Full name
  OFF = "off", // Disable browser autofill
}

// Map from semantic type to HTML autocomplete attribute
export const AUTOCOMPLETE_MAP: Record<AutocompleteSemantic, string> = {
  [AutocompleteSemantic.CITY]: "address-level2",
  [AutocompleteSemantic.STREET]: "address-line1",
  [AutocompleteSemantic.NAME]: "name",
  [AutocompleteSemantic.OFF]: "off",
};
